var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchedulingSectorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0288 19.5V18H17.6923C17.7692 18 17.8397 17.9679 17.9038 17.9038C17.9679 17.8397 18 17.7692 18 17.6923V8.30772H3.99998V12.25H2.5V4.30772C2.5 3.80258 2.675 3.37502 3.025 3.02502C3.375 2.67502 3.80257 2.50002 4.3077 2.50002H5.69233V0.384644H7.23075V2.50002H14.8077V0.384644H16.3076V2.50002H17.6923C18.1974 2.50002 18.625 2.67502 18.975 3.02502C19.325 3.37502 19.5 3.80258 19.5 4.30772V17.6923C19.5 18.1974 19.325 18.625 18.975 18.975C18.625 19.325 18.1974 19.5 17.6923 19.5H14.0288ZM6.99998 21.6442L5.95578 20.6L8.77118 17.75H0.25V16.25H8.77118L5.95578 13.4L6.99998 12.3558L11.6442 17L6.99998 21.6442ZM3.99998 6.80774H18V4.30772C18 4.23078 17.9679 4.16026 17.9038 4.09614C17.8397 4.03204 17.7692 3.99999 17.6923 3.99999H4.3077C4.23077 3.99999 4.16024 4.03204 4.09613 4.09614C4.03203 4.16026 3.99998 4.23078 3.99998 4.30772V6.80774Z",
    fill: "#707683"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedulingSectorIcon);
export default __webpack_public_path__ + "static/media/scheduling-sector-icon.892300c8.svg";
export { ForwardRef as ReactComponent };